module.exports = __webpack_public_path__ + "2a922512e66ed6a4eac78a89002ae321.pdf";